import { DefaultTheme } from 'styled-components'

export const InfinitiTheme: DefaultTheme = {
  colors: {
    primary: '#c3002f',
    tableStriped: '#e9e9e9',
    tableBorder: '#dee2e6',
    footer: '#232323',
    primaryDarken: '#0e233e',
    secondary: '#E3E4E5',
    linkColor: '#4270d2',
    linkColorLight: '#0083c6',
    inputBorder: '#d4d4d4',
    fontColor: '#5b5b5b',
    inputBackgroundColor: '#ffffff',
    mobileMenuBackground: '#f4f4f4',
    sectionContentBackgroundColor: '#f6f6f6',
    borderInput: '1px solid #d4d4d4',
    infoColor: '#6a8c9c',
    successColor: '#26ad77',
    warningColor: '#f90',
    dangerColor: '#b11926',
    ribbonInfoBackgroundColor: '#dae2e6',
    ribbonSuccessBackgroundColor: '#c9eadd',
    ribbonWarningBackgroundColor: '#ffe5bf',
    ribbonDangerBackgroundColor: '#ebc5c9',
    backgroundText: 'white',
    colorTextModal: '#f2dede',
    colorButtonDisabled: '#444',
    switchBackgroundColor: '#6f6f6f',
    headerFontColor: '#494949',
    defaultDealerDeactive: '#A94442',
    incentiveHeaderColor: '#3d6a3c',
    dropdownHoverColor: '#deebff',
    incentiveHeaderHoverColor: '#39a937',
    modalHeader: '#818181',
    carfaxBackground: '#3777bc',
    goodTireColor: '#406a3b',
    normalTireColor: '#e3c35e',
    badTireColor: '#ba0000',
    issueColor: '#b11926',
    defaultTextColor: '#000000',
    stickyTextColor: '#ffffff',
    darkGrayColor: '#606060',
    shadeGrayColor: '#333333',
    hoverConfirmButtonColor: '#a50129',

    loaderColor: 'secondary',

    //Cancel button colors
    cancelButtonBackgroundColor: '#606060',
    cancelButtonColor: '#ffffff',
    cancelButtonHoverBackgroundColor: '#333333',

    //Home Section Header
    homeSectionBackgroundColor: '#B0A591',
    homeSectionBorderColor: '#B0A591',
    homeSectionColor: '##000000',

    InfinitiOnlyColor: '#000000',

    hyperLinkColor: 'rgb(91, 46, 138)',
    hyperLinkHoverColor: 'rgb(155, 129, 252)',
    stepperCompleteColor: '#808080',

    InfinitiLinkColor: '#5b2e8a',
    InfinitiLinkHoverColor: '#9b81fc'
  },
  headerSticky: {
    text: '#000000',
    textHover: '#ffffff',
    backgroundColor: '#B0A591',
    spanUnderline: 'transparent',
    subMenuBackground: '#B0A591',
    subMenuItemBorder: '#ffffff',
    subMenuItemHover: '#ffffff',
    userMenuFont: '#000000'
  },
  headerNotSticky: {
    text: '#000000',
    textHover: '#5b2e8a',
    spanUnderline: '#5b2e8a',
    subMenuBackground: '#ffffff',
    subMenuItemBorder: '#D4D4D4',
    subMenuItemHover: '#000000',
    userMenuFont: '#000000'
  },
  carousel: {
    buttonBackground: '#ffffff',
    buttonColor: '#ffffff',
    buttonBorder: '#000000',
    buttonHoverBackground: '#000000',
    buttonHoverBorderColor: '#000000',
    buttonTextColor: '#000000'
  },
  footer: {
    backgroundColor: '#f5f5f5',
    fontColor: '#666'
  },
  logo: {
    left: 'vendor-main-logo.png',
    right: 'site_title-new.png?version=2'
  },
  fonts: {
    fontBase: 'Nissan Brand',
    fontRegular: 'Nissan Brand'
  }
}
